// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sk-spinner{color:#333}.sk-spinner>div{background-color:currentColor}", ""]);
// Exports
module.exports = exports;
